import { useState, useEffect } from "react";
import SmoothScroll from "@/components/site/SmoothScroll";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import MomStory from "@/components/site/MomStory";
import Categories from "@/components/site/Categories";
import Gifting from "@/components/site/Gifting";
import Testimonials from "@/components/site/Testimonials";
import HowItWorks from "@/components/site/HowItWorks";
import FAQ from "@/components/site/FAQ";
import Footer from "@/components/site/Footer";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";
import PdfViewerModal from "@/components/site/PdfViewerModal";
import PageLoader from "@/components/site/PageLoader";
import { AnimatePresence } from "framer-motion";

export default function Landing() {
  const [isPdfOpen, setIsPdfOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Hide initial loader smoothly after page initialization
    const timer = setTimeout(() => {
      setLoading(false);
    }, 80);
    return () => clearTimeout(timer);
  }, []);

  const openPdf = () => setIsPdfOpen(true);
  const closePdf = () => setIsPdfOpen(false);

  return (
    <>
      <AnimatePresence>{loading && <PageLoader />}</AnimatePresence>
      <SmoothScroll>
      <div
        data-testid="landing-page"
        className="relative bg-[#FAF6F0] text-[#3B2818] min-h-screen"
      >
        <Nav onOpenPdf={openPdf} />
        <main>
          <Hero />
          <Marquee />
          <Categories onOpenPdf={openPdf} />
          <HowItWorks />
          <Manifesto />
          <MomStory />
          <Gifting />
          <Testimonials />
          <FAQ />
        </main>
        <Footer />
        <FloatingWhatsApp />
        <PdfViewerModal isOpen={isPdfOpen} onClose={closePdf} />
      </div>
      </SmoothScroll>
    </>
  );
}
